import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { PayoutMethod, PayoutMethodProvider, PayoutMethodsService } from '../../services/payout-methods.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-payouts-edit',
  templateUrl: './direct-payouts-edit.component.html',
  styleUrls: ['./direct-payouts-edit.component.scss'],
})
export class DirectPayoutsEditComponent implements OnInit {
  stage: number = 1;
  saving: boolean = false;
  payoutMethodId: string;
  payoutMethod: PayoutMethod;

  combinedView: boolean = false;

  PayoutMethodProvider = PayoutMethodProvider;

  overlappingProperties: any[];

  origAllProperties: boolean;

  constructor(
    private route: ActivatedRoute,
    private payoutMethodsService: PayoutMethodsService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((res) => {
      this.payoutMethodId = res.get('payoutId');
      this.combinedView = res.get('combined') ? true : false;
      this.fetchPayoutMethod();
    });
  }

  fetchPayoutMethod() {
    this.payoutMethodsService.fetchPayoutMethods().subscribe((res) => {
      if (!res || res.length === 0) {
        this.redirectAway();
      }

      res.forEach((payout) => {
        if (payout.uuid === this.payoutMethodId) {
          this.payoutMethod = payout;

          this.origAllProperties = this.payoutMethod.all_properties;
        }
      });

      if (!this.payoutMethod) {
        this.redirectAway();
      }
    });
  }

  setProperties(event: { all_properties: boolean; properties: any[] }) {
    this.payoutMethod.property_scope = event.properties;
  }

  updateDefaultPayoutMethod(isDefault: boolean) {
    this.payoutMethod.all_properties = isDefault;
  }

  redirectAway() {
    this.router.navigate(['/direct/payouts']);
  }

  savePayoutMethod() {
    this.saving = true;

    this.payoutMethodsService.editPayoutMethod(this.payoutMethod).subscribe(
      (res) => {
        this.router.navigate(['/direct/payouts']);
      },
      () => {
        this.saving = false;
      }
    );
  }

  deletePayoutMethodConfirm(payout: any) {
    if (!payout.can_delete || this.origAllProperties) {
      return;
    }

    const dialogRef = this.dialog.open(DialogDeleteGenericComponent, {
      width: '720px',
      data: {
        name: 'this payout method',
        identifier: payout.name,
        additionalText:
          payout.property_scope.length > 0
            ? `
          <p>This payout method is being used for bookings on <strong>${payout.property_scope.length} properties</strong>. If you delete it, you'll need to set another payout method on those properties to process bookings.</p>
        `
            : null,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deletePayoutMethod(payout.uuid);
      }
    });
  }

  deletePayoutMethod(uuid: string) {
    this.payoutMethodsService.deletePayoutMethod(uuid).subscribe((res) => {
      this.router.navigate(['/direct/payouts']);
    });
  }

  async checkForOverlappingProperties() {
    this.overlappingProperties = await this.payoutMethodsService.checkForOverlappingProperties(this.payoutMethod);

    if (this.overlappingProperties?.length > 0) {
      return;
    } else {
      this.savePayoutMethod();
    }
  }
}
